import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { OpportunityStatusView } from '@api-proxies';
import { OpportunityStatusService } from '@http/clients/opportunity-status.service';
import { EditorComponentBase, GenericDropdownComponent } from 'ngx-lib';

@Component({
    selector: 'app-opportunity-status-editor',
    templateUrl: './opportunity-status-editor.component.html',
    styleUrls: ['./opportunity-status-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownComponent]
})
export class OpportunityStatusEditorComponent extends EditorComponentBase<number | null> implements OnInit {
    opportunityStatusItems?: OpportunityStatusView[];
    selectedOpportunityStatus?: OpportunityStatusView;

    constructor(private readonly opportunityStatusService: OpportunityStatusService) {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.opportunityStatusItems = await this.opportunityStatusService.getAll();
        if (this.bindingProperty)
            this.selectedOpportunityStatus = this.opportunityStatusItems?.find((x) => x.id === this.bindingProperty);
    }

    onOpportunityStatusChange() {
        this.bindingProperty = this.selectedOpportunityStatus?.id ?? null;
        this.valueChange.emit();
    }
}
